

















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueI18n from '@/i18n';

export default Vue.extend({
  name: 'LoginForm',
  data: () => ({
    valid: true,
    email: '',
    password: '',
    emailRules: [
      (v: string) => !!v || VueI18n.t('loginPage.emailIsRequired'),
      (v: string) => /.+@.+\..+/.test(v) || VueI18n.t('loginPage.emailMustBeValid'),
    ],
    passwordRules: [(v: string) => !!v || VueI18n.t('loginPage.passwordIsRequired')],
  }),
  computed: {
    ...mapGetters('auth', ['isLogged']),
  },
  methods: {
    ...mapActions('auth', ['login']),
    async loginUser(): Promise<void> {
      await this.login({ email: this.email, password: this.password });
      if (this.isLogged) {
        await this.$router.push('/');
      }
    },
  },
});
